import React from "react";

export const Loading = () => {
    return <>
    <div style={{backgroundColor: "#2e8b57", display:"flex", justifyContent:"center", alignItems:"center" ,height:"100vh"}}>
        <img src="/assets/logo1x1.png" alt="" style={{width:"200px",height:"200px"}}/>
    </div>
    </>
}